import { useEffect } from "react";
import { getSiteConfig } from "@/config/siteConfigs";
import { updateGtagConsent } from "@/utils/updateGtagConsent";

const loadGTM = () => {
  if (document.getElementById("gtm-script")) return;

  const siteConfig = getSiteConfig();
  const GTM_ID = siteConfig.gtm.containerId;

  if (!siteConfig.gtm.enabled) return;

  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });
};

const GTMConsentHandler = () => {
  useEffect(() => {
    const consentStatus = localStorage.getItem("cookieConsent");
    const savedSettings = localStorage.getItem("cookieSettings");

    if (consentStatus === "accepted") {
      loadGTM();
      updateGtagConsent({
        necessary: true,
        analytics: true,
        marketing: true,
        preferences: true,
      });
    } else if (consentStatus === "custom" && savedSettings) {
      const settings = JSON.parse(savedSettings);

      if (settings.analytics) {
        loadGTM();
      }

      updateGtagConsent(settings);
    } else if (consentStatus === "declined") {
      updateGtagConsent({
        necessary: true,
        analytics: false,
        marketing: false,
        preferences: false,
      });
    }
  }, []);

  return null;
};

export default GTMConsentHandler;
